import React from 'react';
import { Typography, Box, Grid } from '@mui/material';
import { toLocaleStringIn } from '../../util/general';

interface HoldingsHeaderProps {
  totalInvestedAmount: number;
  totalCurrentValue: number;
  totalPnl: number;
  totalDayPnl: number;
  totalDayChangePercentage: number | null;
}

const HoldingsHeader: React.FC<HoldingsHeaderProps> = ({
  totalInvestedAmount,
  totalCurrentValue,
  totalPnl,
  totalDayPnl,
  totalDayChangePercentage
}) => {

  return (
    <Box sx={{ padding: '12px' }}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={6} sx={{ textAlign: 'center' }}>
          <Typography variant="caption" color="textSecondary">
            Invested
          </Typography>
          <Typography variant="subtitle2">
            {toLocaleStringIn(totalInvestedAmount)}
          </Typography>
        </Grid>
        <Grid item xs={6} sx={{ textAlign: 'center' }}>
          <Typography variant="caption" color="textSecondary">
            Current
          </Typography>
          <Typography variant="subtitle2">
            {toLocaleStringIn(totalCurrentValue)}
          </Typography>
        </Grid>
        <Grid item xs={6} sx={{ textAlign: 'center' }}>
          <Typography variant="caption" color="textSecondary">
            P&L
          </Typography>
          <Typography variant="subtitle2" className={totalPnl < 0 ? 'red-text' : 'green-text'} fontSize={'16px'}>
            {toLocaleStringIn(totalPnl)}
              <span style={{ fontSize: '12px', marginLeft: '4px'}}>
                {totalInvestedAmount > 0 ? (
                  `${totalPnl >= 0 ? '(+' : '('}${((totalPnl / totalInvestedAmount) * 100).toFixed(2)}%)`
                ) : (
                  '(--)'
                )}
              </span>
          </Typography>
        </Grid>
          <Grid item xs={6} sx={{ textAlign: 'center' }}>
              <Typography variant="caption" color="textSecondary">
                  Day's P&L
              </Typography>
              <Typography variant="subtitle2" className={totalDayPnl < 0 ? 'red-text' : 'green-text'} fontSize={'16px'}>
                  {toLocaleStringIn(totalDayPnl)}
                  <span style={{ fontSize: '12px', marginLeft: '4px'}}>
                {totalDayChangePercentage !== null ? (
                  `${totalDayChangePercentage >= 0 ? '(+' : '('}${totalDayChangePercentage.toFixed(2)}%)`
                ) : (
                  '(--)'
                )}
              </span>
              </Typography>
          </Grid>
      </Grid>
    </Box>
  );
};

export default HoldingsHeader;